import { z } from 'zod';

// リクエスト型定義
export interface FetchVideoImagesReq {
  video_id: string;
}

export interface CreateVideoImageReq {
  video_id: string;
  imageFile: File;
  description?: string;
}

export interface UpdateVideoImageReq {
  description?: string;
}

export interface DeleteVideoImageReq {
  id: string;
}

export interface ReorderVideoImagesReq {
  video_id: string;
  order: string[];
}

export interface BatchDeleteVideoImagesReq {
  video_id: string;
  image_ids: string[];
}

export interface ImageOrderItem {
  type: 'existing' | 'new';
  id?: string;        // 既存画像の場合
  temp_id?: string;   // 新規画像の場合
}

export interface UpdateVideoImagesReq {
  image_order: ImageOrderItem[];  // 全画像の順序情報
  delete_image_ids?: string[];
  new_images?: File[];
  new_images_temp_ids?: string[];  // 新規画像の一時IDリスト
  new_images_descriptions?: string[];
}

// レスポンス型定義
export const VideoImageSchema = z.object({
  id: z.string(),
  video_id: z.string(),
  image_path: z.string(),
  description: z.string().optional(),
  position: z.number().optional(),
  display_order: z.number().optional(), // バックエンドから返される表示順序
  created_at: z.string(),
  updated_at: z.string(),
});
export type VideoImage = z.infer<typeof VideoImageSchema>;

// 一時的な画像用の型（ファイルオブジェクトを含む）
export interface TempVideoImage extends VideoImage {
  file?: File;
}

export const VideoImagesResSchema = z.array(VideoImageSchema);
export type VideoImagesRes = z.infer<typeof VideoImagesResSchema>;

export const VideoImageResSchema = VideoImageSchema;
export type VideoImageRes = z.infer<typeof VideoImageResSchema>;

export const VideoImageCreateResSchema = z.object({
  success: z.boolean().optional(),
  message: z.string().optional(),
  image: VideoImageSchema.optional(),
  videoImage: VideoImageSchema.optional(), // バックエンドから返される実際のプロパティ名
});
export type VideoImageCreateRes = z.infer<typeof VideoImageCreateResSchema>;

export const VideoImageUpdateResSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
  image: VideoImageSchema.optional(),
});
export type VideoImageUpdateRes = z.infer<typeof VideoImageUpdateResSchema>;

export const VideoImageDeleteResSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
});
export type VideoImageDeleteRes = z.infer<typeof VideoImageDeleteResSchema>;

export const ReorderVideoImagesResSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
});
export type ReorderVideoImagesRes = z.infer<typeof ReorderVideoImagesResSchema>;

export const BatchDeleteVideoImagesResSchema = z.object({
  message: z.string(),
  deleted_count: z.number(),
  failed_deletions: z.array(z.string()).optional(),
});
export type BatchDeleteVideoImagesRes = z.infer<typeof BatchDeleteVideoImagesResSchema>;

export const UpdateVideoImagesResSchema = z.object({
  message: z.string(),
  updated_images: z.array(VideoImageSchema),
  deleted_count: z.number(),
  added_count: z.number(),
});
export type UpdateVideoImagesRes = z.infer<typeof UpdateVideoImagesResSchema>; 
